/**
=========================================================
* Soft UI Dashboard React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Soft UI Dashboard React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import PageLayout from "examples/LayoutContainers/PageLayout";

// Authentication layout components
import Footer from "layouts/authentication/components/Footer";
import logo from "assets/images/fairsure_logo.png"


function CoverLayout({
  color = "info",
  header = "",
  title = "",
  description = "",
  image = "",
  top = 20,
  children,
}) {
  return (
    <PageLayout background="white">
      <div className="auth-layout">
        <aside className="auth-story">
          <div className="sidebar-brand" style={{ border: 0, padding: 0 }}><span className="brand-mark">F</span><span><strong>Fairsure</strong><small>Payment Limited</small></span></div>
          <div><span className="eyebrow" style={{ color: "#4ade80" }}>Admin workspace</span><h2>Clarity and control for every transaction.</h2><p>Manage merchants, monitor platform finances, and oversee settlements from one workspace.</p></div>
          <p>Fairsure · Financial operations & administration</p>
        </aside>
        <section className="auth-content"><div className="auth-card">{header || <><h1>{title}</h1><p>{description}</p></>}{children}</div></section>
      </div>
    </PageLayout>
  );
}

// Setting default values for the props of CoverLayout
// CoverLayout.defaultProps = {
//   header: "",
//   title: "",
//   description: "",
//   color: "info",
//   top: 20,
// };

// Typechecking props for the CoverLayout
CoverLayout.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
    "light",
  ]),
  header: PropTypes.node,
  title: PropTypes.node,
  description: PropTypes.string,
  image: PropTypes.string,
  top: PropTypes.number,
  children: PropTypes.node.isRequired,
};

export default CoverLayout;
